/** Where the game server lives. Same origin by default (Vite proxies in dev; the server can host the build). */
export const SERVER_URL = (import.meta.env.VITE_SERVER_URL as string | undefined)?.replace(/\/$/, '') || window.location.origin;
export const WS_URL = SERVER_URL.replace(/^http/, 'ws') + '/ws';
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
/** Public address used in invitations and QR codes (e.g. https://party.grudgematchgames.com). */
export const PUBLIC_APP_URL = ((import.meta.env.VITE_PUBLIC_APP_URL as string | undefined) || window.location.origin).replace(/\/$/, '');

export const inviteUrl = (code: string) => `${PUBLIC_APP_URL}/join/${code}`;
/** Audience screen link: just the party code (anyone with the code may show the party on a screen). */
export const displayUrl = (code: string) => `${PUBLIC_APP_URL}/display/${code}`;
